import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import '../styles/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: 'Facebook', icon: faFacebook, url: 'https://facebook.com/anotherphoto.guy' },
    { name: 'Instagram', icon: faInstagram, url: 'https://instagram.com/anotherphoto.guy' },
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-links">
          <h3>follow me</h3>
          <div className="social-icons">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title={link.name}
              >
                <FontAwesomeIcon icon={link.icon} className="social-icon" />
              </a>
            ))}
          </div>
        </div>

        <div className="copyright">
          <p>&copy; {currentYear} Another Photo Guy. All rights reserved.</p>
          <p className="footer-tagline">Coming Soon - Did I tell you that I'm building something?</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

